<template>
  <b-container fluid>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="3" class="pl-0 ml-5">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close"
               @click="filter = ''">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table
      hover
      show-empty
      responsive
      id="mytable"
      :busy.sync="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      @filtered="onFiltered"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу"
      class="my-5"
    >
      <template v-slot:table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка..</strong>
        </div>
      </template>
    </b-table>
    <div class="main-footer">
      <b-form inline>
        <label class="mr-3">Показать</label>
        <b-form-select :options="pageOptions" v-model="perPage"/>
      </b-form>
      <b-pagination align="center"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-6">
      </b-pagination>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100],
      sortBy: '',
      filter: null
    }
  },
  props: ['items', 'fields'],
  watch: {
    items () {
      if (this.items !== null) {
        this.totalRows = this.items.length
      } else {
        this.totalRows = 1
      }
    }
  },
  mounted () {

  },
  computed: {
    ...mapState(
      {
        reportItems: state => state.reports.reportItems,
        isBusy: state => state.reports.busyState
      }
    )
  },
  methods: {
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .table {
    margin-bottom: 0;
  }

  .custom-select {
    font-size: 12px;
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
  }

  .container_search-close:hover {
    border-radius: 50%;
    background-color: #acacac;
  }

  .search-close {
    font-size: 18px;
    color: #acacac;
    cursor: pointer;
    line-height: 18px;
    width: 18px;
    text-align: center;
    margin-bottom: 2px;
  }

  .container_search-close:hover > span {
    color: #fff;
  }
</style>
